import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.js';
import { TableCardTitleWrapper } from './styled.js';
export const TableCardTitle = memo(function TableCardTitle({ className, tooltip, tooltipPosition, children }) {
    return (_jsx(TableCardTitleWrapper, { className: className, children: _jsxs("span", { children: [children, tooltip && _jsx(InfoTooltipIcon, { placement: tooltipPosition, tooltip: tooltip, size: 24 })] }) }));
});
